/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1EditIcon24Solid = forwardRef('People1EditIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18 7A6 6 0 1 1 6 7a6 6 0 0 1 12 0Z" }),
        React.createElement("path", { d: "M17.246 14.754C15.4 14.086 13.397 14 12 14c-2.985 0-8.736.395-9.821 6.01C1.969 21.093 2.895 22 4 22h7v-.172a2 2 0 0 1 .586-1.414l5.66-5.66Z" }),
        React.createElement("path", { d: "M13 21.914V23.5a.5.5 0 0 0 .5.5h1.586a1 1 0 0 0 .707-.293l5.854-5.854-2.5-2.5-5.854 5.854a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m23.677 15.823-1.323 1.323-2.5-2.5 1.323-1.323a1 1 0 0 1 1.414 0l1.086 1.086a1 1 0 0 1 0 1.414Z" })));
});
